import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import CARProof from "@/components/CARProof";
import RedTeamAdmin from "@/components/RedTeamAdmin";
import FederationAdmin from "@/components/FederationAdmin";
import KatlasGovernance from "@/components/KatlasGovernance";
import { PassengerDecisionDemo, AssistedTravelDemo } from "@/components/PassengerDecision";
import { DemoLanding, TravelDemo, PatientDemo, CPSDemo, WalkthroughMode } from "@/components/Governance";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public demos-first landing page */}
        <Route path="/" element={<DemoLanding />} />
        <Route path="/demos" element={<DemoLanding />} />
        <Route path="/demos/travel" element={<TravelDemo />} />
        <Route path="/demos/patient" element={<PatientDemo />} />
        <Route path="/demos/cps" element={<CPSDemo />} />
        
        {/* Guided walkthrough for video recording */}
        <Route path="/walkthrough" element={<WalkthroughMode />} />
        
        {/* Technical/Admin routes - not shown on public landing */}
        <Route path="/technical" element={<CARProof />} />
        <Route path="/admin/redteam" element={<RedTeamAdmin />} />
        <Route path="/admin/federation" element={<FederationAdmin />} />
        <Route path="/passenger" element={<PassengerDecisionDemo />} />
        <Route path="/passenger/assisted" element={<AssistedTravelDemo />} />
        <Route path="/governance" element={<KatlasGovernance />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
